export const animateDots = () => {

  const containerSelectors = [
    {
      selector: '.sticky-header-and-column-text .first-column',
      enableParallax: true,
      divider: 2
    },
    {
      selector: '.slider-wrapper',
      enableParallax: true,
      divider: 2
    },
    {
      selector: '.slider-video',
      enableParallax: true,
      divider: 2
    },
    {
      selector: '.video-with-animated-background',
      enableParallax: true,
      divider: 2
    },
    {
      selector: '.text-container',
      enableParallax: false,
      divider: 10
    },
    {
      selector: '.download-form',
      enableParallax: true,
      divider: 2
    },
    {
      selector: '.get-in-touch',
      enableParallax: true,
      divider: 2
    },
    {
      selector: '.single-content-wrapper',
      enableParallax: false,
      divider: 10
    },
    {
      selector: '.industries-wrapper',
      enableParallax: false,
      divider: 10
    },
    {
      selector: '.prefooter-form',
      enableParallax: false,
      divider: 10
    },
    {
      selector: '.clients',
      enableParallax: false,
      divider: 10
    },
    {
      selector: '.slider-posts--v2',
      enableParallax: false,
      divider: 10
    },
    {
      selector: '.products--v2',
      enableParallax: false,
      divider: 10
    }
  ];

  containerSelectors?.forEach(({selector, enableParallax, divider}) => {
    const containers = document.querySelectorAll(selector);

    if (!containers) {
      return;
    }

    containers.forEach(container => {
      const circles = container.querySelectorAll('.circle');
      applyCirclesAnimations(container, circles, enableParallax, divider);
    });
  });

  function applyCirclesAnimations(container, circles, enableParallax, divider) {
    let entryAnimationCompleted = 0;
    
    circles.forEach((circle) => {

      circle.addEventListener('transitionend', () => {

        // increment the counter when a circle finishes its entry animation - transitionend event
        entryAnimationCompleted++;

        // all circles have finished their entry animation
        if (entryAnimationCompleted === circles.length) {
          container.addEventListener('mousemove', (e) => handleMouseMove(e, divider));

          if (enableParallax) {
            window.addEventListener('scroll', function () {
              if (container.classList.contains('animated')) {
                requestAnimationFrame(() => applyParallax(container, circles));
              }
            });
          }
        }
      });
    });

    let mouseMovePending = false;
    function handleMouseMove(e, divider) {
      if (!mouseMovePending) {
        requestAnimationFrame(() => followCursor(e, divider));
        mouseMovePending = true;
      }
    }

    function followCursor(e, divider) {
      const { left, top } = container.getBoundingClientRect();
      const x = e.clientX - left;
      const y = e.clientY - top;

      circles.forEach((circle, index) => {
        const speed = (index + 1) * 0.01;
        const xPos = (x - container.offsetWidth / divider) * speed;
        const yPos = (y - container.offsetHeight / divider) * speed;

        circle.style.transform = `translate(${xPos}px, ${yPos}px)`;
      });

      mouseMovePending = false;
    }
  }

  function applyParallax(container, circles) {
    let scrollPosition = window.scrollY;
    let containerPosition = container.offsetTop;
    let containerHeight = container.offsetHeight;

    if (scrollPosition > containerPosition - window.innerHeight &&
      scrollPosition < containerPosition + containerHeight) {
      circles.forEach((circle, index) => {
        let parallaxValue = (scrollPosition - containerPosition) * 0.01 * (index + 1);
        circle.style.transform = `translateY(${parallaxValue}px)`;
      });
    }
  }
}
